import AuthUserSelector from '../modules/authorisation/AuthUserSelector';

export default (state, all = true, modules = []) => {
  if (all) {
    return {
      ...AuthUserSelector(state),
      app: state.get('app'),
    };
  }

  let stateInProps = {};

  if (modules.includes('app')) {
    stateInProps = Object.assign({}, stateInProps, { app: state.get('app') });
  }

  if(modules.includes('receipt')) {
    stateInProps = Object.assign({}, stateInProps, { receipt: state.get('receipt') });
 }

  return stateInProps;
};
